function Postcard( options ){
	this.className = "Postcard";
	if(options) this.setup.apply(this, arguments);
};
Postcard.inheritsFrom( EventTarget );
Postcard.prototype.setup = function({
    template,
    $elem,
    items,
    item,
}){
    this.$body = $("body");

	// Template
    this.template = template ? template : "postcard";
    const compiled = Handlebars.compile($("#"+this.template).html());
	const html = compiled(item);
    this.$postcard 			= this.$body.append(html).find(".js-postcard");

	this.$card 				= this.$postcard.find('.js-card');
	this.$zoomOut			= this.$body.find('.js-zoom-out');
	this.$slideshowSlide 	= this.$postcard.find('js-slideshow-slide');

    // Vars
    this.items = items;
    this.currentItem = item;
    this.currentSlide = 0;

    // Setup slideshow
    this.setupSlideshow();
    if(this.currentItem){
    	this.currentSlide = this.items.indexOf(this.currentItem);
	}
	this.gotoSlide(this.currentSlide);


	// Show postcard
	this.$postcard.css("opacity",1);

	// Auto flip
	this.flipTimeout = setTimeout(() => { this.flipCard() }, 5000);

	/*
	setTimeout(() => {
		const $html = $('.card-back');
		$html.removeClass('card-back');
		setTimeout(() => {
			$html.addClass('card-back')
		},1);
	}, 1);
	*/

    // Card flip on click
	this.$cardFlip = this.$postcard.find('.js-postcard-flip');
	this.$cardFlip.on('click', (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.flipCard();
	});

	// Slideshow controls
	this.$slideshowControl = this.$postcard.find('.js-slideshow-control');
	this.$slideshowControl.on("click", (e) => {
		e.preventDefault();
		const $this = $(e.currentTarget);
		const direction = $this.attr('data-direction');
		if(direction === 'left'){
			this.previousSlide();
		}else{
			this.nextSlide();
		}
	});

	/*
	this.$postcardthis.$postcard.find('.js-postcard-background');
	this.$close.on("click", (e) => {
		e.preventDefault();
		this.close();
	});
	*/

	// Close
	this.$close = this.$postcard.find('.js-postcard-close, .js-postcard-background');
	this.$close.on("click", (e) => {
		e.preventDefault();
		this.close();
	});

	// Keypress
	this.keydownDelegate = (e) => {
		if(e.which === 27){
			e.preventDefault();
			e.stopPropagation();
			this.close();
		}
	};
    this.$body.on("keydown",this.keydownDelegate);
}
Postcard.prototype.gotoSlide = function(index){
	const slide = this.items[index];
	if(!slide) return;

	if(this.currentSlide !== index){
		this.close();
		this.setup({
			items: this.items,
			item: slide,
		});
	}

	this.currentSlide = index;
}
Postcard.prototype.nextSlide = function(){
	let nextSlide = this.currentSlide+1;
	if(nextSlide >= this.items.length) nextSlide = 0;

	if(this.items[nextSlide].skip){
		nextSlide = nextSlide + 1;
	}

	this.gotoSlide(nextSlide);
}
Postcard.prototype.previousSlide = function(){
	let previousSlide = this.currentSlide-1;
	if(previousSlide <= 0) previousSlide = this.items.length-1;

	if(this.items[previousSlide].skip){
		previousSlide = previousSlide - 1;
	}

	this.gotoSlide(previousSlide);
}
Postcard.prototype.setupSlideshow = function(){
	for(let index in this.items){
		const item = this.items[index];
		item['index'] = index*1;
	}
	console.log(this.items);
}
Postcard.prototype.flipCard = function(){
	if(this.flipTimeout) clearTimeout(this.flipTimeout);

	const $card = this.$card;
	if(!$card) return;

	this.$cardFlip.toggleClass('flipped');

	if($card.hasClass('card--flipped')) {
		$card.addClass('card--unflip');
		setTimeout(() => {
			$card.removeClass('card--flipped card--unflip');
		}, 500);

	} else {
		$card.addClass("card--flipped");
	}
};
Postcard.prototype.close = function(options){
	const e = jstage.fire("close");
	if(!e.preventedDefault) this.destroy();
}
Postcard.prototype.destroy = function(options){
	if(this.$close) this.$close.off("click");
	if(this.flipTimeout) clearTimeout(this.flipTimeout);
	this.$postcard.remove();
	$("body").off("keydown",this.keydownDelegate);
}
